// extracted by mini-css-extract-plugin
export default {"dropdownTitle":"styles_dropdownTitle__3xUF6","dropdownPopup":"styles_dropdownPopup__0NdGS"};